"use strict";
/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Permission = void 0;
/**
 * Nom de la permission vérifiée
 * @example "counter_sale:execute"
 */
var Permission;
(function (Permission) {
    Permission["CounterSaleExecute"] = "counter_sale:execute";
    Permission["PaymentValidationBypassAll"] = "payment_validation:bypass_all";
})(Permission || (exports.Permission = Permission = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9fdGVtcC9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsb0JBQW9CO0FBQ3BCLG9CQUFvQjtBQUNwQjs7Ozs7OztHQU9HOzs7QUE4OUJIOzs7R0FHRztBQUNILElBQVksVUFHWDtBQUhELFdBQVksVUFBVTtJQUNwQix5REFBMkMsQ0FBQTtJQUMzQywwRUFBNEQsQ0FBQTtBQUM5RCxDQUFDLEVBSFcsVUFBVSwwQkFBVixVQUFVLFFBR3JCIn0=